import React, { useState, useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import SwapNewCard from '../components/SwapNew/SwapNewCard';
import SwapForm from '../components/SwapNew/SwapForm';
import SwapWalletsList from '../components/SwapNew/SwapWalletsList';
import SwapOffers from '../components/SwapOffers';
import SwapConfirm from '../components/SwapConfirm';
import SwapBack from '../components/SwapNew/SwapBack';
import Button from '../components/Button';
import SwapNetworkWarn from '../components/SwapNew/SwapNetworkWarn';
import { ReactComponent as WalletIcon } from '../img/default-svg/wallet.svg';
import { ReactComponent as WalletIconFinvaro } from '../img/finvaro/wallet.svg';
import { ReactComponent as WalletIconClarnium } from '../img/clarnium/wallet.svg';
import { ReactComponent as WalletIconInex } from '../img/inex/wallet.svg';
import { ReactComponent as WalletIconInsta } from '../img/instaXchange/wallet.svg';
import { ReactComponent as WarningIcon } from '../img/default-svg/info-circle-warning.svg';
import uploadFile from '../img/cpay-svg/upload.svg';
import { useHistory, useLocation } from 'react-router-dom';
import debounce from 'lodash/debounce';
import { getAdminFeeWalletsSwap } from '../redux/actions/adminPanel/adminFeeWallets';

import {
  getSwapOffers,
  updateSwapOffers,
  swapOffersUpdateApply,
  swapOffersReset,
  swapExchangeWalletsReset,
  resetExchangeError,
  getSwapTokens,
  getReceiveSwap,
  swapReceiveReset,
  resetStableSwapError,
  getSwapExchangeWallets,
} from '../redux/actions/swap';
import { useTranslation } from 'react-i18next';
import { checkAutosignStatus, uploadNewAutosign } from '../redux/actions/withdraw';
import { getMerchantWallets } from '../redux/actions/merchantWallets';
import { compareNewTokensArrays } from '../utils/compareNewTokensArrays';
import UploadAutosignWrapper from '../components/Withdraw/UploadAutosignWrapper';
import { identity } from '../utils/getIdentity';
import { cryptoApi } from '../service/cryptopay-api';
import { notificationsErrorShow } from '../redux/actions/notifications';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const walletIcon = {
  cpay: <WalletIcon />,
  nfg: <WalletIcon />,
  finvaro: <WalletIconFinvaro />,
  clarnium: <WalletIconClarnium />,
  inex: <WalletIconInex />,
  insta: <WalletIconInsta />,
};

const SwapNew = ({
  exchangeWallets,
  exchangeWalletsFetching,
  swapBestOffer,
  swapOffers,
  updatedOffers,
  getSwapOffers,
  swapOffersReset,
  swapOffersFetching,
  swapWalletsReset,
  updateSwapOffers,
  swapOffersUpdateApply,
  swapOffersUpdating,
  currenciesArray,
  resetExchangeError,
  getSwapTokens,
  swapTokens,
  getReceiveSwap,
  priceForSwap,
  swapReceiveReset,
  resetStableSwapError,
  merchantId,
  networkFilter,
  getSwapExchangeWallets,
  checkAutosignStatus,
  autosignStep,
  autosignStatus,
  merchantData,
  type = 'user',
}) => {
  const [socket, setSocket] = useState(undefined);
  const [isFetched, setIsFetched] = useState(false);
  const [walletFromId, setWalletFromId] = useState('');
  const [walletToId, setWalletToId] = useState('');
  const [selectedWalletBalance, setSelectedWalletBalance] = useState(0);
  const [showBalanceWarning, setShowBalanceWarning] = useState(false);
  const [adminExchangeWallets, setAdminExchangeWallets] = useState([]);
  const [exchangeWalletsFrom, exchangeWalletsTo] = exchangeWallets;
  const [showSwapOffers, setShowSwapOffers] = useState(false);
  const [swapOffersSort, setSwapOffersSort] = useState('rate');
  const [swapOffersType, setSwapOffersType] = useState('');
  const [selectedPartner, setSelectedPartner] = useState('');
  const [selectedSwapFixed, setSelectedSwapFixed] = useState(undefined);
  const [selectedPartnerRateId, setSelectedPartnerRateId] = useState('');
  const [summaryRate, setSummaryRate] = useState(0);
  const [swapAmountFromError, setSwapAmountFromError] = useState(null);
  const [fees, setFees] = useState(null);
  const [bridge, setBridge] = useState('');
  const [loadingFees, setLoadingFees] = useState(false);
  const [isLoadingSwing, setIsLoadingSwing] = useState(false);
  const [exchangeFields, setExchangeFields] = useState([
    {
      index: 0,
      value: 0,
      selectedCurrency: '',
      chainSymbol: '',
      name: '',
    },
    {
      index: 1,
      value: 0,
      selectedCurrency: '',
      chainSymbol: '',
      name: '',
    },
  ]);

  const [polkaDotLimitWarning, setPolkaDotLimitWarning] = useState(false);
  const [dataIsFrozen, setDataIsFrozen] = useState(false);
  const [newCurrencyForSwap, setNewCurrencyForSwap] = useState([]);
  const [showSwapConfirmModal, setShowSwapConfirmModal] = useState(false);

  const [isOpenAutosignModal, setIsOpenAutosignModal] = useState(false);
  const [isShowAutosignModal, setIsShowAutosignModal] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [password, setPassword] = useState('');
  const [sign, setSign] = useState('');
  const [rate, setRate] = useState(0);

  const ratesFetchTimer = useRef();
  const history = useHistory();
  const youSendAmountRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const walletVersion = merchantData?.settingWallet?.version || localStorage.getItem('walletVersion');
  const getWalletAssets = wallet =>
    wallet?.tokens?.length > 0
      ? wallet.tokens
      : (wallet?.balances || []).map(asset => ({
          currency: asset?.currency?.name,
          currencyId: asset?.currency?.id,
          balance: asset?.balance,
          holdBalance: asset?.holdBalance,
          nodeType: asset?.currency?.nodeType,
        }));
  const getWalletAssetByCurrencyId = (wallet, currencyId) =>
    getWalletAssets(wallet)?.find(asset => asset?.currencyId === currencyId);

  const defaultFilterValues = {
    order: 'DESC',
    search: '',
    limit: 5,
    currencyIds: currenciesArray.filter(currency => currency.currencyType === 'currency').map(currency => currency._id),
    typeNetwork: networkFilter,
  };

  const isSwapStable = location.pathname === '/swap/create/stable';
  const isAdmin = location?.pathname === '/admin/swap/create';
  const isSwapSwing = location.pathname === '/swap/create/swing';

  // useEffect(() => {
  //   getSwapTokens();
  // }, []);

  useEffect(() => {
    if (isAdmin && exchangeFields[0].selectedCurrency && exchangeFields[1].selectedCurrency) {
      dispatch(
        getAdminFeeWalletsSwap({
          limit: -1,
          typeWallet: 'merchant',
          typeNetwork: networkFilter,
          currencyIds: [`${exchangeFields[0].selectedCurrency}`, `${exchangeFields[1].selectedCurrency}`] || undefined,
        })
      );
    }
  }, [isAdmin, networkFilter, exchangeFields[0].selectedCurrency, exchangeFields[1].selectedCurrency]);

  // useEffect(() => {
  //   setNewCurrencyForSwap(compareNewTokensArrays(swapTokens, currenciesArray));
  // }, [currenciesArray, swapTokens]);

  const [currencyFieldIsEdited, setCurrencyFieldIsEdited] = useState('none');

  useEffect(
    () => () => {
      ratesFetchTimer.current && clearTimeout(ratesFetchTimer.current);
      swapOffersReset();
      swapWalletsReset();
      swapReceiveReset();
    },
    []
  );

  useEffect(() => {
    if (swapOffers && swapOffers.length) {
      setExchangeFields([
        {
          ...exchangeFields[0],
        },
        {
          ...exchangeFields[1],
          value: isSwapStable ? priceForSwap?.amountToBeReceived : swapBestOffer?.toAmount || swapOffers[0].toAmount,
        },
      ]);
    }
  }, [swapBestOffer, swapOffers, priceForSwap]);

  useEffect(() => {
    if (
      walletFromId &&
      exchangeFields[0].value &&
      +exchangeFields[0].value &&
      `${exchangeFields[0].value}`.split('').pop() !== '.'
    ) {
      setShowBalanceWarning(+exchangeFields[0].value > selectedWalletBalance ? true : false);
    }
  }, [exchangeFields, selectedWalletBalance, walletFromId]);

  useEffect(() => {
    if (exchangeFields[0].value && +exchangeFields[0].value && `${exchangeFields[0].value}`.split('').pop() !== '.') {
      setShowBalanceWarning(+exchangeFields[0].value > selectedWalletBalance ? true : false);
      if (isSwapStable) {
        setFetchTimer(getReceiveSwap, {
          sourceChain: exchangeFields[0].chainSymbol,
          destinationChain: exchangeFields[1].chainSymbol,
          amount: exchangeFields[0].value,
          fromToken: exchangeFields[0].name,
          toToken: exchangeFields[1].name,
        });
      } else if (!isSwapSwing) {
        setFetchTimer(getSwapOffers, {
          fromId: exchangeFields[0].selectedCurrency,
          toId: exchangeFields[1].selectedCurrency,
          amount: exchangeFields[0].value,
          sort: swapOffersSort || undefined,
          type: swapOffersType || undefined,
        });
      }
    }
  }, [
    exchangeFields[0].value,
    exchangeFields[0].selectedCurrency,
    exchangeFields[0]?.contractAddress,
    exchangeFields[1]?.contractAddress,
    exchangeFields[1].selectedCurrency,
    swapOffersSort,
    swapOffersType,
  ]);

  useEffect(() => {
    if (!isSwapStable && exchangeFields[0].value && walletFromId && exchangeWalletsFrom &&
        walletToId && exchangeWalletsTo) {
      const walletAddress = exchangeWalletsFrom?.entities?.filter(item => item?._id === walletFromId);

      if (!isAdmin && !isSwapSwing) {
        debouncedGetFeeEstimate.current(
          merchantId,
          walletFromId,
          walletAddress[0]?.address,
          String(exchangeFields[0].value),
          exchangeFields[0].selectedCurrency,
          exchangeFields[1].selectedCurrency,
          undefined,
          password || undefined,
          sign || undefined,
          true
        );
      } else if (!isSwapSwing) {
        debouncedGetFeeEstimateAdmin.current(
          walletFromId,
          walletAddress[0]?.address,
          String(exchangeFields[0].value),
          exchangeFields[0].selectedCurrency,
          true
        );
      }
    }
  }, [exchangeFields[0]?.value, walletFromId, walletToId]);

  const formatAmount = (amount, decimals) => {
    return Number(amount) / Math.pow(10, decimals);
  };

  useEffect(() => {
    if (
      isSwapSwing &&
      walletFromId &&
      walletToId &&
      exchangeFields[0]?.value &&
      exchangeFields[0].selectedCurrency &&
      exchangeFields[1].selectedCurrency
    ) {
      debouncedGetFeeEstimateSwing.current({
        currencyFromId: exchangeFields[0].selectedCurrency,
        fromId: walletFromId,
        currencyToId: exchangeFields[1].selectedCurrency,
        toId: walletToId,
        amount: exchangeFields[0].value,
      });
    }
  }, [
    walletFromId,
    walletToId,
    exchangeFields[0]?.value,
    exchangeFields[0].selectedCurrency,
    exchangeFields[1].selectedCurrency,
  ]);

  const updateValue = (index, newValue) => {
    setExchangeFields(prevFields =>
      prevFields.map(field => (field.index === index ? { ...field, value: newValue } : field))
    );
  };

  const debouncedGetFeeEstimateSwing = useRef(
    debounce(async body => {
      setLoadingFees(true);
      setIsLoadingSwing(true);
      setRoutes([]);

      try {
        const response = await cryptoApi.getSwingEstimate(body);
        setRoutes(response?.data?.routes);

        updateValue(
          1,
          formatAmount(response?.data?.routes[0]?.quote?.amount, response?.data?.routes[0]?.quote?.decimals)
        );
      } catch (error) {
        setRoutes([]);
        dispatch(notificationsErrorShow({ message: error?.data?.message || '' }));
      }

      setLoadingFees(false);
      setIsLoadingSwing(false);
    }, 3000)
  );

  const debouncedGetFeeEstimate = useRef(
    debounce(async (...params) => {
      setLoadingFees(true);

      try {
        const response = await cryptoApi.getFeeEstimate(...params);
        setFees(response && response.data ? response.data : null);
      } catch (error) {
        setFees('');
        dispatch(notificationsErrorShow({ message: error?.data?.message || '' }));
      }

      setLoadingFees(false);
    }, 3000)
  );

  const debouncedGetFeeEstimateAdmin = useRef(
    debounce(async (...params) => {
      try {
        const response = await cryptoApi.getFeeEstimateAdmin(...params);
        setFees(response && response.data ? response.data : null);
      } catch (error) {
        setFees('');
        dispatch(notificationsErrorShow({ message: error.data.message }));
      }

      setLoadingFees(false);
    }, 3000)
  );

  useEffect(() => {
    if (!exchangeFields[0].value && exchangeFields[0].selectedCurrency && exchangeFields[1].selectedCurrency) {
      setExchangeFields([
        {
          ...exchangeFields[0],
        },
        {
          ...exchangeFields[1],
          value: 0,
        },
      ]);
    }
  }, [exchangeFields[0].value]);

  useEffect(() => {
    if (exchangeFields[0].value === 0 || exchangeFields[0].value === '') setPolkaDotLimitWarning(false);
    if (swapAmountFromError) setSwapAmountFromError(null);
  }, [exchangeFields[0].value]);

  useEffect(() => {
    if (exchangeWalletsFrom && exchangeWalletsFrom.entities.length) {
      setWalletFromId(exchangeWalletsFrom.entities[0]._id);
      const selectedAsset = getWalletAssetByCurrencyId(
        exchangeWalletsFrom.entities[0],
        exchangeFields[0].selectedCurrency
      );
      setSelectedWalletBalance(
        +(selectedAsset?.balance?.value ?? exchangeWalletsFrom.entities[0]?.balance?.value ?? 0)
      );
    }
  }, [exchangeWalletsFrom, exchangeFields[0].selectedCurrency]);

  useEffect(() => {
    if (exchangeWalletsTo && exchangeWalletsTo.entities.length) {
      setWalletToId(exchangeWalletsTo.entities[0]._id);
    }
  }, [exchangeWalletsTo]);

  const setFetchTimer = async (action, value) => {
    ratesFetchTimer.current && clearTimeout(ratesFetchTimer.current);
    ratesFetchTimer.current = setTimeout(() => action(value), 2000);
  };
  const { t } = useTranslation();

  const handleErrorMsgClick = () => {
    setSelectedPartner(undefined);
    setSelectedPartnerRateId('');
    setBridge('');
    resetExchangeError();
    resetStableSwapError();
    youSendAmountRef.current = null;
    if (isSwapStable) {
      setShowSwapConfirmModal(false);
      setDataIsFrozen(true);
    }
  };

  useEffect(() => {
    if (swapAmountFromError) {
      youSendAmountRef.current = exchangeFields[0].value;
      setExchangeFields([{ ...exchangeFields[0] }, { ...exchangeFields[1] }]);
    }
  }, [swapAmountFromError]);

  useEffect(() => {
    if (polkaDotLimitWarning) setShowSwapOffers(false);
  }, [polkaDotLimitWarning]);

  useEffect(() => {
    socket && socket.disconnect();
    setSocket(undefined);
    createSocket(merchantId);
  }, [merchantId]);

  const createSocket = merchantId => {
    const io = window.io;
    const socket = io(process.env.REACT_APP_API_URL, {
      allowEIO3: true,
      withCredentials: true,
    });
    socket.on('connect', () => {
      socket.emit('sign-in-merchant', { token: localStorage.getItem('authToken'), merchantId });
      setSocket(socket);
    });
    socket.on('updatedBalance', () => {
      if (merchantId && walletVersion) {
        getSwapExchangeWallets(merchantId, {
          limit: -1,
          typeWallet: 'merchant',
          typeNetwork: networkFilter,
          currencyIds: [`${exchangeFields[0].selectedCurrency}`, `${exchangeFields[1].selectedCurrency}`] || undefined,
          walletVersion,
        });
      }
    });
    socket.on('disconnect', function () {});
  };

  const uploadAutosign = data => {
    const { password, sign } = data;
    setPassword(password || undefined);
    setSign(sign || undefined);

    setIsOpenAutosignModal(false);
  };

  useEffect(() => {
    if (walletFromId && !isAdmin) {
      checkAutosignStatus(merchantId, walletFromId);
    }
  }, [merchantId, walletFromId]);

  useEffect(() => {
    setIsShowAutosignModal(autosignStatus);
  }, [autosignStatus]);

  const handleExchange = () => {
    setSelectedPartner(swapBestOffer.partner);
    setSelectedSwapFixed(swapBestOffer.fixed);
    setSummaryRate(swapBestOffer.toAmount);
    setSelectedPartnerRateId(swapBestOffer.id);
    setDataIsFrozen(true);
  };

  return !isSwapStable && selectedPartner && selectedSwapFixed !== undefined && !bridge ? (
    <>
      <SwapBack
        action={() => {
          setSelectedPartner(undefined);
          setBridge('');
          setSelectedPartnerRateId('');
        }}
        maxWidth={790}
      />
      <SwapConfirm
        fromId={walletFromId}
        toId={walletToId}
        rate={rate}
        currencyFromId={exchangeFields[0].selectedCurrency}
        currencyToId={exchangeFields[1].selectedCurrency}
        amount={youSendAmountRef.current ? youSendAmountRef.current : exchangeFields[0].value}
        summaryRate={summaryRate}
        setSummaryRate={setSummaryRate}
        partner={selectedPartner}
        fixed={selectedSwapFixed}
        selectedPartnerRateId={selectedPartnerRateId}
        swapOffers={swapOffers}
        priceForSwap={priceForSwap}
        updatedOffers={updatedOffers}
        swapOffersReset={swapOffersReset}
        swapReceiveReset={swapReceiveReset}
        setSwapOffersType={setSwapOffersType}
        setSelectedPartner={setSelectedPartner}
        setSelectedPartnerRateId={setSelectedPartnerRateId}
        setShowSwapOffers={setShowSwapOffers}
        updateSwapOffers={updateSwapOffers}
        swapOffersUpdateApply={swapOffersUpdateApply}
        swapOffersUpdating={swapOffersUpdating}
        sort={swapOffersSort || undefined}
        type={swapOffersType || undefined}
        handleErrorMsgClick={handleErrorMsgClick}
        setSwapAmountFromError={setSwapAmountFromError}
        sign={sign}
        password={password}
        pageType={type}
        bridge={bridge}
      />
    </>
  ) : isSwapStable && showSwapConfirmModal ? (
    <>
      <SwapBack
        action={() => {
          setBridge('');
          setShowSwapConfirmModal(false);
          setDataIsFrozen(true);
          setExchangeFields([
            {
              ...exchangeFields[0],
            },
            {
              ...exchangeFields[1],
            },
          ]);
        }}
        maxWidth={790}
      />
      <SwapConfirm
        fromId={walletFromId}
        toId={walletToId}
        rate={rate}
        currencyFromId={exchangeFields[0].selectedCurrency}
        currencyToId={exchangeFields[1].selectedCurrency}
        amount={youSendAmountRef.current ? youSendAmountRef.current : exchangeFields[0].value}
        summaryRate={summaryRate}
        setSummaryRate={setSummaryRate}
        partner={selectedPartner}
        fixed={selectedSwapFixed}
        selectedPartnerRateId={selectedPartnerRateId}
        swapOffers={swapOffers}
        priceForSwap={priceForSwap}
        updatedOffers={updatedOffers}
        swapOffersReset={swapOffersReset}
        swapReceiveReset={swapReceiveReset}
        setSwapOffersType={setSwapOffersType}
        setSelectedPartner={setSelectedPartner}
        setSelectedPartnerRateId={setSelectedPartnerRateId}
        setShowSwapOffers={setShowSwapOffers}
        updateSwapOffers={updateSwapOffers}
        swapOffersUpdateApply={swapOffersUpdateApply}
        swapOffersUpdating={swapOffersUpdating}
        sort={swapOffersSort || undefined}
        type={swapOffersType || undefined}
        handleErrorMsgClick={handleErrorMsgClick}
        setSwapAmountFromError={setSwapAmountFromError}
        isSwapStable={isSwapStable}
        exchangeFields={exchangeFields}
        newCurrencyForSwap={newCurrencyForSwap}
        password={password}
        sign={sign}
        pageType={type}
        isSwapSwing={isSwapSwing}
        bridge={bridge}
      />
    </>
  ) : isSwapSwing && bridge ? (
    <>
      <SwapBack
        action={() => {
          setShowSwapConfirmModal(false);
          setDataIsFrozen(true);
          setBridge('');
          setExchangeFields([
            {
              ...exchangeFields[0],
            },
            {
              ...exchangeFields[1],
            },
          ]);
        }}
        maxWidth={790}
      />
      <SwapConfirm
        fromId={walletFromId}
        toId={walletToId}
        rate={rate}
        currencyFromId={exchangeFields[0].selectedCurrency}
        currencyToId={exchangeFields[1].selectedCurrency}
        amount={youSendAmountRef.current ? youSendAmountRef.current : exchangeFields[0].value}
        summaryRate={summaryRate}
        setSummaryRate={setSummaryRate}
        partner={selectedPartner}
        fixed={selectedSwapFixed}
        selectedPartnerRateId={selectedPartnerRateId}
        swapOffers={swapOffers}
        priceForSwap={priceForSwap}
        updatedOffers={updatedOffers}
        swapOffersReset={swapOffersReset}
        swapReceiveReset={swapReceiveReset}
        setSwapOffersType={setSwapOffersType}
        setSelectedPartner={setSelectedPartner}
        setSelectedPartnerRateId={setSelectedPartnerRateId}
        setShowSwapOffers={setShowSwapOffers}
        updateSwapOffers={updateSwapOffers}
        swapOffersUpdateApply={swapOffersUpdateApply}
        swapOffersUpdating={swapOffersUpdating}
        sort={swapOffersSort || undefined}
        type={swapOffersType || undefined}
        handleErrorMsgClick={handleErrorMsgClick}
        setSwapAmountFromError={setSwapAmountFromError}
        isSwapStable={isSwapStable}
        exchangeFields={exchangeFields}
        newCurrencyForSwap={newCurrencyForSwap}
        password={password}
        sign={sign}
        pageType={type}
        bridge={bridge}
      />
    </>
  ) : (
    <>
      <div className="swap-wallets">
        <SwapNetworkWarn />
        <SwapBack
          action={() => {
            if (type === 'user') {
              if (isSwapSwing) {
                localStorage.setItem('swing', 'swing');
                history.push('/swap');
              } else {
                history.push('/swap');
              }
            } else {
              history.push('/admin/swap');
            }
          }}
          maxWidth={790}
        />
        <SwapNewCard title={t('swap.steps.stepOne')} className={`swap-exchange-wrap swap-exchange-wrap-${identity}`}>
          {!isShowAutosignModal && !isAdmin && (
            <div
              className={`withdraw__autosign withdraw__autosign-${identity}`}
              onClick={() => setIsOpenAutosignModal(true)}
            >
              <img src={uploadFile} alt="upload" />
              <span>{!sign ? t('withdraw.uploadAutosign') : `${sign.slice(0, 15)}...`}</span>
            </div>
          )}
          <SwapForm
            swingLoading={isLoadingSwing}
            exchangeFields={exchangeFields}
            setExchangeFields={setExchangeFields}
            walletFromId={walletFromId}
            exchangeWalletsFrom={exchangeWalletsFrom}
            destinationToken={exchangeFields[1].selectedCurrency}
            swapOffers={swapOffers}
            priceForSwap={priceForSwap}
            swapOffersFetching={swapOffersFetching}
            swapOffersReset={swapOffersReset}
            swapReceiveReset={swapReceiveReset}
            swapOffersUpdating={swapOffersUpdating}
            polkaDotLimitWarning={polkaDotLimitWarning}
            setPolkaDotLimitWarning={setPolkaDotLimitWarning}
            dataIsFrozen={dataIsFrozen}
            setDataIsFrozen={setDataIsFrozen}
            swapAmountFromError={swapAmountFromError}
            setSwapAmountFromError={setSwapAmountFromError}
            youSendAmountRef={youSendAmountRef}
            setCurrencyFieldIsEdited={setCurrencyFieldIsEdited}
            currencyFieldIsEdited={currencyFieldIsEdited}
            isSwapStable={isSwapStable}
            newCurrencyForStableSwap={newCurrencyForSwap}
            password={password}
            sign={sign}
          />
          {!isSwapStable && !isSwapSwing && (
            <div className="withdraw-fee">
              <div className={`withdraw-fee__title withdraw-fee__title-${identity}`}>{t('total')}</div>
              <div className={`withdraw-fee__value withdraw-fee__value-${identity}`}>
                <span className={`withdraw-fee__description withdraw-fee__description-${identity}`}>
                  {!isAdmin ? t('wallets.feeCalc') : t('wallets.feeCalcAdmin')}:
                </span>
                <span>
                  {exchangeFields[0].value && !loadingFees ? exchangeFields[0].value : ''}
                  {loadingFees ? (
                    <Spin
                      indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />}
                    />
                  ) : (
                    <span>
                      {fees
                        ? ` + ${fees?.minerFee} ${fees?.currencyMinerFee} ${!isAdmin ? '+' : ''} ${!isAdmin ? fees?.systemFee : ''} ${!isAdmin ? fees?.currencyFee : ''}`
                        : ''}
                    </span>
                  )}
                </span>
              </div>
            </div>
          )}
        </SwapNewCard>
        {showBalanceWarning && (
          <div className="swap-wallets__warning">
            <WarningIcon />
            {t('swap.newSwap.warning')}
          </div>
        )}
        <SwapNewCard
          title={t('swap.steps.stepTwo')}
          buttonComponent={
            exchangeWalletsFrom &&
            exchangeWalletsFrom.entities.length > 1 && (
              <div
                className={`swap-new-card__button swap-new-card__button-${identity}`}
                onClick={() => {
                  setWalletFromId('');
                  setSelectedWalletBalance(0);
                }}
              >
                {walletIcon[identity]}
                {t('swap.newSwap.change')}
              </div>
            )
          }
        >
          <SwapWalletsList
            exchangeWallets={exchangeWalletsFrom}
            activeWalletId={walletFromId}
            handleSelect={setWalletFromId}
            setSelectedWalletBalance={setSelectedWalletBalance}
            exchangeWalletsFetching={exchangeWalletsFetching}
            currenciesArray={!isSwapStable ? currenciesArray : newCurrencyForSwap}
            currencyFieldIsEdited={currencyFieldIsEdited}
            currencyNumber={0}
            selectedCurrencyId={exchangeFields[0].selectedCurrency}
          />
        </SwapNewCard>

        <SwapNewCard
          title={t('swap.steps.stepThree')}
          buttonComponent={
            exchangeWalletsTo &&
            exchangeWalletsTo.entities.length > 1 && (
              <div
                className={`swap-new-card__button swap-new-card__button-${identity}`}
                onClick={() => !swapOffersUpdating && setWalletToId('')}
              >
                {walletIcon[identity]}
                {t('swap.newSwap.change')}
              </div>
            )
          }
        >
          <SwapWalletsList
            exchangeWallets={exchangeWalletsTo}
            activeWalletId={walletToId}
            handleSelect={setWalletToId}
            exchangeWalletsFetching={exchangeWalletsFetching}
            swapOffersUpdating={swapOffersUpdating}
            currenciesArray={!isSwapStable ? currenciesArray : newCurrencyForSwap}
            currencyFieldIsEdited={currencyFieldIsEdited}
            currencyNumber={1}
            selectedCurrencyId={exchangeFields[1].selectedCurrency}
          />
        </SwapNewCard>
        {!showSwapOffers && !isSwapStable && !isSwapSwing && (
          <div className="swap-wallets__button">
            <Button
              disabled={
                !walletFromId ||
                !walletToId ||
                !+exchangeFields[0].value ||
                exchangeFields[1].value === 0 ||
                polkaDotLimitWarning || 
                !swapBestOffer
              }
              onClick={handleExchange}
            >
              {t('swap.newSwap.quick_swap')}
            </Button>
            <Button
              disabled={
                !walletFromId ||
                !walletToId ||
                !+exchangeFields[0].value ||
                exchangeFields[1].value === 0 ||
                polkaDotLimitWarning
              }
              onClick={() => setShowSwapOffers(true)}
            >
              {t('swap.newSwap.offers')}
            </Button>
          </div>
        )}

        {isSwapSwing && !showSwapOffers && (
          <div className="swap-wallets__button">
            <Button disabled={routes?.length < 1} onClick={() => setShowSwapOffers(true)}>
              {t('swap.newSwap.offers')}
            </Button>
          </div>
        )}

        {isSwapStable && (
          <div className="swap-wallets__button">
            <Button
              disabled={
                !walletFromId ||
                !walletToId ||
                !+exchangeFields[0].value ||
                exchangeFields[1].value === 0 ||
                polkaDotLimitWarning
              }
              onClick={() => setShowSwapConfirmModal(true)}
            >
              {t('Send')}
            </Button>
          </div>
        )}

        {showSwapOffers && (
          <SwapOffers
            currencies={currenciesArray}
            swapOffers={swapOffersType === 'fixed' ? swapOffers.filter(offer => offer.id) : swapOffers}
            updatedOffers={updatedOffers}
            setSwapOffersSort={setSwapOffersSort}
            setSwapOffersType={setSwapOffersType}
            setSelectedPartner={setSelectedPartner}
            setBridge={setBridge}
            setSelectedSwapFixed={setSelectedSwapFixed}
            setSelectedPartnerRateId={setSelectedPartnerRateId}
            setSummaryRate={setSummaryRate}
            swapOffersFetching={swapOffersFetching}
            amount={exchangeFields[0].value}
            fromId={exchangeFields[0].selectedCurrency}
            toId={exchangeFields[1].selectedCurrency}
            sort={swapOffersSort || undefined}
            type={swapOffersType || undefined}
            updateSwapOffers={updateSwapOffers}
            swapOffersUpdateApply={swapOffersUpdateApply}
            swapOffersUpdating={swapOffersUpdating}
            showBalanceWarning={showBalanceWarning}
            setDataIsFrozen={setDataIsFrozen}
            swapOffersSort={swapOffersSort}
            swapOffersType={swapOffersType}
            setSwapAmountFromError={setSwapAmountFromError}
            swapAmountFromError={swapAmountFromError}
            polkaDotLimitWarning={polkaDotLimitWarning}
            isSwapSwing={isSwapSwing}
            routes={routes}
            setRate={setRate}
          />
        )}
      </div>
      <UploadAutosignWrapper
        step={autosignStep}
        uploadAutosign={uploadAutosign}
        onCancel={() => setIsOpenAutosignModal(false)}
        isOpen={isOpenAutosignModal}
      />
    </>
  );
};

const mapStateToProps = state => ({
  merchantId: state.transactions.merchantId,
  networkFilter: state.networkFilter,
  exchangeWallets: state.swap.exchangeWallets.data,
  exchangeWalletsFetching: state.swap.exchangeWallets.fetching,
  swapBestOffer: state.swap.bestOffer.data,
  swapOffers: state.swap.offers.data,
  updatedOffers: state.swap.updatedOffers.data,
  swapOffersFetching: state.swap.offers.fetching,
  swapOffersUpdating: state.swap.updatedOffers.fetching,
  currenciesArray: state.currencies.data,
  swapTokens: state.swap.tokens.tokens,
  priceForSwap: state.swap.priceForSwap.data,
  autosignStatus: state.withdraw.autosignStatus,
  autosignError: state.withdraw.autosignError,
  autosignStep: state.withdraw.autosignStep,
  merchantData: state.merchantData.data,
  feeWallets: state.adminFeeWallets.entities,
});

const mapDispatchToProps = dispatch => ({
  getSwapOffers: getSwapOffers(dispatch),
  updateSwapOffers: updateSwapOffers(dispatch),
  swapOffersUpdateApply: () => dispatch(swapOffersUpdateApply()),
  swapOffersReset: () => dispatch(swapOffersReset()),
  swapWalletsReset: () => dispatch(swapExchangeWalletsReset()),
  resetExchangeError: () => dispatch(resetExchangeError()),
  getSwapTokens: getSwapTokens(dispatch),
  getReceiveSwap: getReceiveSwap(dispatch),
  swapReceiveReset: () => dispatch(swapReceiveReset()),
  resetStableSwapError: () => dispatch(resetStableSwapError()),
  getMerchantWallets: getMerchantWallets(dispatch),
  getSwapExchangeWallets: dispatch(getSwapExchangeWallets),
  checkAutosignStatus: checkAutosignStatus(dispatch),
  uploadNewAutosign: uploadNewAutosign(dispatch),
  // getMerchantBalances: getMerchantBalances(dispatch),
  // getWithdrawWallets: getWithdrawWallets(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SwapNew);
